var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "yxt-form",
        {
          ref: "form",
          attrs: {
            model: _vm.libForm,
            "label-position": "top",
            size: "small",
            rules: _vm.rules,
            "label-width": "76px",
          },
        },
        [
          _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_biz_ote_lbl_queslibcatalog"),
                prop: "catalogId",
                error: _vm.validCatalogMsg,
              },
            },
            [
              _c("catalogDropdown", {
                attrs: {
                  data: _vm.datas,
                  catalogId: _vm.libForm.catalogId,
                  catalogName: _vm.libForm.catalogName,
                },
                on: {
                  "update:catalogId": function ($event) {
                    return _vm.$set(_vm.libForm, "catalogId", $event)
                  },
                  "update:catalog-id": function ($event) {
                    return _vm.$set(_vm.libForm, "catalogId", $event)
                  },
                  "update:catalogName": function ($event) {
                    return _vm.$set(_vm.libForm, "catalogName", $event)
                  },
                  "update:catalog-name": function ($event) {
                    return _vm.$set(_vm.libForm, "catalogName", $event)
                  },
                  change: _vm.catalogChange,
                },
              }),
            ],
            1
          ),
          _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_biz_ote_lbl_quesbankname"),
                prop: "name",
                error: _vm.validNameMsg,
              },
            },
            [
              _c("yxt-input", {
                attrs: {
                  disabled: _vm.shareSourceType === 1,
                  placeholder: _vm.$t("pc_ote_msg_inputqueslibname"),
                  maxlength: "200",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.libForm.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.libForm, "name", $$v)
                  },
                  expression: "libForm.name",
                },
              }),
            ],
            1
          ),
          _c(
            "yxt-form-item",
            { attrs: { label: _vm.$t("pc_ote_lbl_queslibsecrecy") } },
            [
              _c(
                "yxt-radio-group",
                {
                  attrs: { disabled: _vm.shareSourceType === 1 },
                  model: {
                    value: _vm.libForm.secrecy,
                    callback: function ($$v) {
                      _vm.$set(_vm.libForm, "secrecy", $$v)
                    },
                    expression: "libForm.secrecy",
                  },
                },
                [
                  _vm.checkActionAdminPermission(
                    "questionBank_add_oepn_operate"
                  )
                    ? _c(
                        "yxt-radio",
                        { attrs: { label: 0, disabled: false } },
                        [_vm._v(_vm._s(_vm.$t("pc_ote_lbl_public")))]
                      )
                    : _c(
                        "yxt-tooltip",
                        {
                          attrs: {
                            content: _vm.$t(
                              "pc_ote_no_open_queslib_create_per" /* 无公开题库创建权限，如有疑问请联系管理员 */
                            ),
                            placement: "top",
                          },
                        },
                        [
                          _c(
                            "yxt-radio",
                            { attrs: { label: 0, disabled: "lock" } },
                            [_vm._v(_vm._s(_vm.$t("pc_ote_lbl_public")))]
                          ),
                        ],
                        1
                      ),
                  _vm.checkActionAdminPermission(
                    "questionBank_add_private_operate"
                  )
                    ? _c(
                        "yxt-radio",
                        { attrs: { label: 1, disabled: false } },
                        [_vm._v(_vm._s(_vm.$t("pc_ote_tip_secrecy")))]
                      )
                    : _c(
                        "yxt-tooltip",
                        {
                          attrs: {
                            content: _vm.$t(
                              "pc_ote_no_secret_queslib_create_per" /* 无保密题库创建权限，如有疑问请联系管理员 */
                            ),
                            placement: "top",
                          },
                        },
                        [
                          _c(
                            "yxt-radio",
                            { attrs: { label: 1, disabled: "lock" } },
                            [_vm._v(_vm._s(_vm.$t("pc_ote_tip_secrecy")))]
                          ),
                        ],
                        1
                      ),
                ],
                1
              ),
              _c("span", { staticClass: "color-gray-7 v-mid d-in-block mt2" }, [
                _vm._v(
                  "（" +
                    _vm._s(_vm.$t("pc_ote_tip_questionbanksecrecyeditable")) +
                    "）"
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }